import React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import { tokens } from "../../utils/figmaTokens";
import { countText } from "../../utils/kitPresentation";

// A list's one-at-a-time views as a row of pills (Saved views 10620:2423): the chosen pill is
// brand blue with a darker count, the others white with a grey count. A count shows once it is
// a number. From md up the row is Figma's 100 px tall; on a phone it only wraps.
const ViewChips = ({ caption, views, value, counts = {}, onChange, disabled = false }) => (
  <Box role="group" aria-label={caption} sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "8px", minHeight: { md: 100 } }}>
    <Typography variant="labelCaption" sx={{ color: tokens.text.tertiary }}>
      {caption}
    </Typography>
    {views.map((view) => {
      const on = view.key === value;
      const count = counts[view.key];
      return (
        <ButtonBase
          key={view.key || "all"}
          onClick={() => onChange(view.key)}
          disabled={disabled}
          aria-pressed={on}
          sx={{
            gap: "6px",
            px: "11px",
            py: "6px",
            borderRadius: "999px",
            border: `1px solid ${on ? tokens.brand.primary : tokens.border.default}`,
            bgcolor: on ? tokens.brand.primary : tokens.surface.default,
            color: on ? tokens.brand.on : tokens.text.secondary,
            typography: "labelMedium",
            whiteSpace: "nowrap",
            "&:hover": { bgcolor: on ? tokens.brand.primary : tokens.hover },
            "&.Mui-disabled": { opacity: 0.45 },
            // D22's ring, drawn outside the pill: inside, it would vanish on the blue chosen pill.
            "&.Mui-focusVisible": { outline: `2px solid ${tokens.brand.border}`, outlineOffset: "2px" },
          }}
        >
          {view.label}
          {typeof count === "number" && (
            <Box
              component="span"
              sx={{ px: "6px", borderRadius: "999px", bgcolor: on ? tokens.brand.hover : tokens.surface.muted, typography: "labelCaption" }}
            >
              {countText(count)}
            </Box>
          )}
        </ButtonBase>
      );
    })}
  </Box>
);

export default ViewChips;
